import { gql } from "@apollo/client"
import {
  TriggerEngagementInvitationNotificationsInput,
  TriggerEngagementInvitationNotificationsPayload,
} from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"

export const TRIGGER_ENGAGEMENT_INVITATION_NOTIFICATIONS_QUERY = gql`
  mutation TriggerEngagementInvitationNotifications($engagementId: ID!) {
    triggerEngagementInvitationNotifications(input: { engagementId: $engagementId }) {
      engagement {
        id
        invitation {
          id
          sentAt
        }
        hiring {
          id
          companyProcess {
            steps {
              name
              progress
            }
            currentStep {
              name
            }
          }
        }
      }
      errors
    }
  }
`

export default (
  options?: InjectedOptions<
    TriggerEngagementInvitationNotificationsPayload,
    TriggerEngagementInvitationNotificationsInput
  >,
) =>
  useMutation<
    TriggerEngagementInvitationNotificationsPayload,
    TriggerEngagementInvitationNotificationsInput
  >(TRIGGER_ENGAGEMENT_INVITATION_NOTIFICATIONS_QUERY, options)
